/* eslint-disable react/require-default-props */
import {Link} from "react-router-dom"

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography'

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import {
  EQUIPMENT_URLS,
  HAND_SELECTION_URLS,
  OPERATING_ENVIRONMENT_URLS,
  OPERATING_TEST_URLS,
  SYSTEM_URLS,
  WORK_URLS,
  TRAJECTORY_URLS
} from '../constants/constants'
import {ROLE_KEYS, useUserRole} from '../utils/awsConfigure';

function FeatureList(props: {
  title: string;
  icon?: string;
  alt?: string;
  requiredRoles?: string[]
  items: {
    url: string;
    title: string | JSX.Element;
    icon: string;
    alt: string;
    requiredRoles?: string[]
  }[]
}) {
  const {userRole} = useUserRole();

  if(!props.requiredRoles || props.requiredRoles.includes(userRole)){
    return (
      <>
        <Box component="section" sx={{mt:2, display: 'flex', flexDirection: 'row', alignContent: 'center'}}>
          { props.icon && props.alt &&
            <img src={props.icon} alt={props.alt} style={{width: 40, height: 40, marginRight:"8px"}}/>
          }
          <Typography variant="h5" component="span" sx={{fontWeight: 500, lineHeight: 'normal'}}>
            {props.title}
          </Typography>
        </Box>
        <Container sx={{py: 2, gap: 3, display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
          {props.items.map((item) => {
            if(!item.requiredRoles || item.requiredRoles.includes(userRole)){
              return (
                <Link key={item.url} to={item.url} style={{textDecoration: 'none'}}>
                  <Card sx={{width: 190, height: 190, my:1, mx:0.5, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <CardContent>
                      <Box display='flex' justifyContent='center' sx={{mb:1}}>
                        <img src={item.icon} alt={item.alt} style={{width: 90, height: 90}}/>
                      </Box>
                      <Typography variant="h6" color="primary.main" align="center">
                        {item.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </Link>
              )
            }
            return null;
          })}
        </Container>
      </>
    )
  }
  return null;
}

export default function Top() {
  return (
    <Container sx={{py: 5}}>

      <Typography variant="subtitle2" sx={{mb: 4}}>
        本DBに登録されているデータは研究目的で使用するための仮登録データであり、公表を意図したものではありません。
      </Typography>

      <FeatureList
        title="データの登録・参照"
        items={[{
          url: WORK_URLS.WORK_LIST.URL,
          title: "対象物DB",
          icon: "/icons/category_icon.svg",
          alt: "Work DB",
        },
        {
          url: EQUIPMENT_URLS.HAND_LIST.URL,
          title: "機器DB",
          icon: "/icons/robot_icon.svg",
          alt: "Equipment DB",
          requiredRoles:[ROLE_KEYS.ADMIN, ROLE_KEYS.ARM_MAKER, ROLE_KEYS.HAND_MAKER, ROLE_KEYS.SIER]
        },
        {
          url: OPERATING_ENVIRONMENT_URLS.OBJECT_LIST.URL,
          title: "動作環境DB",
          icon: "/icons/world_icon.svg",
          alt: "Operating Environment DB",
        },
        {
          url: TRAJECTORY_URLS.TRAJECTORY_REGISTE.URL,
          title: "軌道DB",
          icon: "/icons/trending_up.svg",
          alt: "Trajectory DB",
        },
        {
          url: SYSTEM_URLS.SYSTEM_LIST.URL,
          title: "システム事例DB",
          icon: "/icons/system_icon.svg",
          alt: "System DB",
          requiredRoles:[ROLE_KEYS.ADMIN, ROLE_KEYS.ARM_MAKER, ROLE_KEYS.HAND_MAKER, ROLE_KEYS.SIER]
        }]}
      />

      <FeatureList
        title="データの活用ツール"
        requiredRoles={[ROLE_KEYS.ADMIN, ROLE_KEYS.ARM_MAKER, ROLE_KEYS.HAND_MAKER, ROLE_KEYS.SIER]}
        items={[{
          url: HAND_SELECTION_URLS.BEGINNING_WORK.URL,
          title: "ハンド選択支援",
          icon: "/icons/search_icon.svg",
          alt: "Hand Selection DB",
        },
        {
          url: OPERATING_TEST_URLS.SIMULATION.URL,
          title: <span>動作試験<span style={{display:"block",fontSize:"0.95rem"}}>（シミュレーション）</span></span>,
          icon: "/icons/view_in_ar.svg",
          alt: "Operating Test DB",
        }]}
      />

    </Container>
  )
}